<template>
    <el-card class="displaysettings absolute top-right fs-3 zi-100">
        <div class="flex-level mt-O pb-3 bb-1">
            <h3 class="flex m-0">
                {{ exportType === 'advanced' ? $l10n.__('Export avancé') : $l10n.__('Export %(type)s', { type:  exportType.toUpperCase() }) }}
            </h3>
            <a
                class="close-btn"
                @click.prevent="$store.commit(`${listinghash}/hideDisplay`, 'export')"
            >
                &times;
            </a>
        </div>

        <p
            v-if="
                listingname == 'aged-accounts-payable' ||
                listingname == 'aged-accounts-receivable' ||
                exportType === 'fec'
            "
        >
            {{
                $l10n.__('Vous allez lancer un export des informations affichées dans votre liste.')
            }}
        </p>
        <p v-else>
            {{
                $l10n.__(
                    'Vous allez lancer un export des informations affichées dans votre liste. Pour gérer les informations exportées, rendez-vous dans la gestion des colonnes.',
                )
            }}
        </p>
        <p>
            {{
                $l10n.__(
                    'En fonction de la taille de votre fichier, un délai de quelques minutes est parfois nécessaire avant de recevoir automatiquement un lien de téléchargement dans votre boite email : ',
                )
            }}
            <span class="semibold">{{ userEmail }}</span>
        </p>

        <div v-if="['csv', 'advanced'].includes(exportType)">
            <div v-if="exportType === 'advanced'">
                <h5 class="pb-1 semibold">
                    {{ $l10n.__("Format de l'export") }}
                </h5>

                <div class="form-input block mb-1">
                    <label for="allcolumns_false">
                        <select
                            id="advanced_format"
                            v-model="selectedAdvancedFormat"
                        >
                            <option v-for="advancedFormat in advancedFormats" :key="advancedFormat" :value="advancedFormat">
                                {{ advancedFormat.toUpperCase() }}
                            </option>
                        </select>
                    </label>
                </div>
            </div>

            <div>
                <h5 class="pb-1 semibold">
                    {{ $l10n.__("Sélection de l'export") }}
                </h5>

                <div class="form-input block mb-1">
                    <label for="allcolumns_false">
                        <input
                            id="allcolumns_false"
                            v-model="allColumns"
                            type="radio"
                            value="false"
                            :disabled="importFormat"
                        />
                        {{
                            $l10n.__(
                                'Je souhaite exporter uniquement les colonnes affichées dans la liste',
                            )
                        }}
                    </label>
                </div>
                <div class="form-input block">
                    <label for="allcolumns_true">
                        <input
                            id="allcolumns_true"
                            v-model="allColumns"
                            type="radio"
                            value="true"
                            :disabled="importFormat"                            
                        />
                        {{ $l10n.__('Je souhaite exporter la totalité des colonnes') }}
                    </label>
                </div>
            </div>

            <div v-if="exportType == 'csv'">
                <h5 class="pb-1 semibold">
                    {{ $l10n.__("Encodage de l'export") }}
                </h5>

                <div class="form-input block mb-1">
                    <label
                        v-for="(char, index) in availableCharsets"
                        :key="index"
                        :for="`encode-${index}`"
                    >
                        <input
                            :id="`encode-${index}`"
                            v-model="charset"
                            type="radio"
                            :value="char"
                            :disabled="importFormat"
                        />
                        {{ char }}
                    </label>
                </div>
            </div>

            <div
                v-if="['csv', 'advanced'].includes(exportType) && Object.keys(exportOptions).length > 0"
                class="form-group-block mt-3"
            >
                <h5 class="pb-1 semibold">
                    {{ $l10n.__('Options') }}
                </h5>

                <div v-for="(label, key) in exportOptions" :key="key" class="form-input block mb-1">
                    <label :for="'export_option_' + key">
                        <input
                            :id="'export_option_' + key"
                            v-model="exportOptionsValues"
                            type="checkbox"
                            :value="key"
                            :disabled="importFormat"
                        />
                        {{ label }}
                    </label>
                </div>
            </div>

            <div v-if="exportType == 'csv' && hasFullExport" class="form-group-block mt-3">
                <h5 class="form-label label-auto pb-1 semibold">
                    {{ $l10n.__('Format import') }}
                </h5>

                <p class="mt-0">
                    {{
                        $l10n.__(
                            'Le format import vous permet d’exporter l’ensemble des colonnes nécessaires pour une mise à jour via un import.',
                        )
                    }}
                </p>

                <div class="form-input">
                    <label for="import_format">
                        <input id="import_format" v-model="importFormat" type="checkbox" />
                        {{ $l10n.__('Exporter au format import') }}
                    </label>
                </div>

                <div v-if="importFormat" class="form-input">
                    <label for="import_customfields">
                        <input
                            id="import_customfields"
                            v-model="includeCustomFields"
                            type="checkbox"
                        />
                        {{ $l10n.__('Inclure les champs personnalisés') }}
                    </label>
                </div>
            </div>
        </div>
        <div v-else-if="exportType == 'pdf'">
            <el-checkbox v-if="hasKpis" v-model="addKpis">
                {{ $l10n.__('Inclure le récapitulatif') }}
            </el-checkbox>
        </div>

        <div class="aright mt-5">
            <CompassButton
                :label="$t.__('listing.ExportModal.export')"
                :disabled="loading"
                @click="launchExport"
            />
        </div>
    </el-card>
</template>

<script>
import _ from 'lodash';
import { watch } from 'vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('user');

export default {
    props: {
        listinghash: {
            type: String,
            required: true,
        },
        exportType: {
            type: String,
            required: true,
        },
        allColumnOption: {
            type: Boolean,
            default: true,
        },
        exportOptions: {
            type: Object,
            required: false,
            default: function () {
                return {};
            },
        },
        hasKpis: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            charset: localStorage.getItem('charset-export')
                ? localStorage.getItem('charset-export')
                : 'UTF-8',
            availableCharsets: ['UTF-8', 'ISO-8859-1'],
            importFormat: false,
            includeCustomFields: false,
            allColumns: false,
            loading: false,
            exportOptionsValues: [],
            addKpis: false,
            selectedAdvancedFormat: 'ndjson',
            advancedFormats: ['ndjson', 'parquet']
        };
    },
    computed: {
        listingname() {
            return this.$store.state[this.listinghash].listingname;
        },
        meta() {
            return this.$store.getters[`${this.listinghash}/meta`];
        },
        hasFullExport() {
            return this.$store.state[this.listinghash].hasFullExport;
        },
        exportAllColumns() {
            return this.allColumns === true || this.allColumns === 'true';
        },

        ...mapState({
            userEmail: 'email',
        }),
    },
    watch: {
        importFormat(val) {
            if (val) {
                this.resetExportOptionsValues();
            }
        },
    },
    methods: {
        resetExportOptionsValues() {
            this.exportOptionsValues = [];
        },
        launchExport() {
            this.loading = true;

            const data = {
                meta: this.meta,
                listingname: this.listingname,
                outputFormat: this.exportType,
            };

            switch (this.exportType) {
                case 'csv':
                    data.importFormat = this.importFormat;
                    data.charset = this.charset;
                    data.includeCustomFields = this.includeCustomFields;
                    data.allColumns = this.exportAllColumns;
                    data.options = this.exportOptionsValues;
                    localStorage.setItem('charset-export', data.charset);
                    break;
                case 'pdf':
                    data.options = {
                        addKpis: this.addKpis,
                    };
                    break;
                case 'fec':
                    data.allColumns = true;
                    break;
                case 'advanced':
                    data.allColumns = this.exportAllColumns;
                    data.options = this.exportOptionsValues;
                    data.outputFormat = this.selectedAdvancedFormat;
                    break;
            }

            this.$store
                .dispatch(`${this.listinghash}/runExport`, data)
                .then((result) => {
                    this.$store.commit(`${this.listinghash}/hideDisplay`, 'export');
                    let title, message;
                    if (result.workerSent) {
                        EventBus.emit('listing:export', { hash: this.listinghash });
                        title = this.$l10n.__('Export en cours de traitement');
                        message = this.$l10n.__(
                            "Nous sommes en train de générer le fichier d'export.  Vous recevrez un email avec un lien de téléchargement lorsque le fichier sera prêt",
                        );
                    } else if (result.workerSent != undefined) {
                        title = this.$l10n.__('Un export est déjà en cours pour ce listing');
                        message = this.$l10n.__(
                            'Vous avez déjà demandé un export pour ce listing, attendez que cet export soit fini avant de ré-exporter',
                        );
                    }
                    Push.success(message, title);
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    const message = this.$l10n.__(
                        "Une erreur s'est produite lors du lancement de l'export",
                    );
                    Push.error(message);
                    throw new Error(JSON.stringify(error));
                });
        },
    },
};
</script>

<style lang="sass" scoped>
.displaysettings{
    width:592px;
}
</style>
